module.exports = __webpack_public_path__ + "img/rechange_fail.a817d554.png";